import eorderingLogo from "@assets/images/eOrdering.png";
import scgpLogo from "@assets/images/SCGP-color.svg";
import { Box, Button, Dialog, Paper } from "@material-ui/core";
import { ANNOUNCE_MESSAGE_DATE } from "@saleor/config";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

import MyTypography from "../MyTypography";

interface DialogUserAnnouncementProps {
  open: boolean;
  onClose(): void;
}

const useStyles = makeStyles(
  {
    root: {
      padding: "5rem 2.5rem",
      backgroundColor: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      maxWidth: "570px",
      margin: "0 auto"
    },
    logo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
      marginBottom: "20px",
      "& > img:first-child": {
        height: "25px"
      },
      "& > img:last-child": {
        height: "60px"
      },
      "& > span": {
        width: "1px",
        height: "60px",
        backgroundColor: "#A90C55"
      }
    },
    title: {
      fontWeight: 700,
      color: "#333",
      marginBottom: "1rem",
      textDecoration: "underline"
    },
    desc: {
      color: "#333",
      marginBottom: "3rem",
      whiteSpace: "pre-wrap",
      textAlign: "center"
    },
    danger: {
      color: "#FF0000",
      fontWeight: 700
    },
    closeBtn: {
      fontSize: "16px",
      display: "block",
      margin: "0 auto",
      padding: "1rem 7rem",
      color: "white",
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      "&:hover": {
        opacity: 0.85
      }
    }
  },
  { name: "DialogUserAnnouncement" }
);

const DialogUserAnnouncement: React.FC<DialogUserAnnouncementProps> = props => {
  const classes = useStyles();
  const messageDate = ANNOUNCE_MESSAGE_DATE;

  return (
    <Dialog data-testid="dialog-userAnnouncement" open={props.open}>
      <Paper className={classes.root}>
        <Box className={classes.logo}>
          <img src={scgpLogo} alt="SCGP eOrdering" />
          <Box component="span"></Box>
          <img src={eorderingLogo} alt="E-Ordering" />
        </Box>
        <MyTypography variant="body2" className={classes.desc}>
          <p className={classes.title}>
            เรียน ท่านผู้ใช้งานระบบ SCGP E-Ordering
          </p>
          <p>
            บริษัทฯ ขอแจ้งปิดระบบ SCGP E-Ordering
            เพื่อปรับปรุงระบบให้มีประสิทธิภาพมากขึ้น{" "}
            {!!messageDate && (
              <span className={classes.danger}>{messageDate}</span>
            )}
            <br />
            <br />
            **บริษัทฯ ต้องขออภัยในความไม่สะดวกมา ณ ที่นี้**
          </p>
        </MyTypography>
        <Button onClick={props.onClose} className={classes.closeBtn}>
          ตกลง
        </Button>
      </Paper>
    </Dialog>
  );
};

export default DialogUserAnnouncement;
